<template>
  <div v-if="kits && kits?.items?.length" class="product-kits">
    <h3 class="def-header-3">{{ title }}</h3>
    <div class="product-kits__controls">
      <span
        v-for="({ id, name }, i) in getTags"
        :key="id"
        :class="{ 'product-kits__button_active': i === activeTabIndex }"
        class="product-kits__button"
        @click="activeTabIndex = i"
      >
        {{ name }}
      </span>
    </div>

    <PerfectScrollbar class="product-kits__block">
      <ProductKitsCard
        v-for="item in kitsArray"
        :key="item?.offer?.id || item?.id"
        :result="item"
      />
      <ProductKitsTotal :result="activeTab" :kits="kitsArray" :active-tab-index="activeTabIndex" />
    </PerfectScrollbar>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ProductKitsCard from '@components/Product/ProductKits/ProductKitsCard/ProductKitsCard.vue';
import ProductKitsTotal from '@components/Product/ProductKits/ProductKitsTotal/ProductKitsTotal.vue';
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';

export default {
  name: 'ProductKits',
  components: { ProductKitsTotal, ProductKitsCard, PerfectScrollbar },
  data() {
    return {
      activeTabIndex: 0,
    };
  },
  computed: {
    ...mapState({
      kits: ({ product }) => product.data?.product?.kits,
      title: ({ product }) => product.data?.product?.kits?.title,
      tabs: ({ product }) => product.data?.product?.kits?.tabs,
      product: ({ product }) => product.data?.product,
    }),
    activeTab() {
      return this.tabs?.[this.activeTabIndex];
    },
    kitsArray() {
      try {
        if (this.activeTab?.kit) {
          return [this.product, ...this.activeTab?.kit];
        }
        return [];
      } catch (err) {
        console.error(err);
        return [];
      }
    },
    getTags() {
      return this.tabs.filter((el) => el.kit);
    },
  },
};
</script>

<style lang="scss">
.product-kits {
  margin: 48px 0 28px;
  @include point-md {
    margin: 64px 0 44px;
  }

  &__controls {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: rem(12);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #757575;
    margin-bottom: 34px;
  }

  &__button {
    transition: 0.2s linear color, 0.2s linear text-decoration-color;
    text-decoration: underline;
    text-underline-position: under;
    text-decoration-color: transparent;
    &:not(:last-child) {
      margin-right: 28px;
      @include point-md {
        margin-right: 31px;
      }
    }

    &:hover {
      cursor: pointer;
    }

    &_active {
      color: var(--text-colour-secondary);
      text-decoration-color: currentColor;
    }
  }

  &__block {
    display: flex;
    flex-direction: column;
    @include point-md {
      position: relative;
      flex-direction: row;
      overflow-x: auto;
      padding-bottom: 20px;
    }
  }
}
</style>
